import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter',
  // optional: pure: false for impure pipes that re-run on every change detection cycle
})
export class FilterPipe implements PipeTransform {
  transform<T>(
    items: T[] | null | undefined,
    searchText: string,
    propertyNames?: string[] | string
  ): T[] {
    // Return items as-is if null, undefined, or searchText is empty
    if (!items || !searchText) {
      return items || [];
    }

    // Normalize search text
    searchText = searchText.toLowerCase().trim();

    return items.filter((item) => {
      // If propertyNames is provided, filter on specified properties
      if (propertyNames) {
        const props = Array.isArray(propertyNames)
          ? propertyNames
          : [propertyNames];
        return props.some((prop) => {
          const value = item[prop as keyof T];
          // Only include items where the property value is a string and matches searchText
          return (
            typeof value === 'string' &&
            value.toLowerCase().includes(searchText)
          );
        });
      } else {
        // Fallback: convert entire item to string (useful for primitive arrays)
        return String(item).toLowerCase().includes(searchText);
      }
    });
  }
}
